import { useEffect } from 'react'

// UX43: streak-milestone celebration. Center overlay for the moments
// that deserve it (7 / 30 / 100 / 365 days). Non-blocking — auto-
// dismisses in ~4.5s, backdrop click + × + Escape all close early.
// Fires at most once per milestone (persisted via quillStreak state's
// lastMilestoneShown field).

const COPY = {
  7:   { emoji: '🔥', text: '7-day streak', sub: "You're on a roll." },
  30:  { emoji: '🎊', text: '30-day streak', sub: 'A whole month of civic habit.' },
  100: { emoji: '💯', text: '100-day streak', sub: "You're a civic powerhouse." },
  365: { emoji: '🏛', text: '1-year streak', sub: 'A full year. Legendary.' },
}

export function StreakCelebration({ days, onClose, saved = false, daysHeld }) {
  // UX47: 'saved' variant celebrates a rescued streak. Days = the
  // restored count. daysHeld = the quill's lifetime so we can namecheck it.
  const copy = saved
    ? {
        emoji: '🪶',
        text: 'Streak saved!',
        sub: `Your ${days}-day run is back — nice save.`,
      }
    : (COPY[days] || {
        emoji: '🔥',
        text: `${days}-day streak`,
        sub: 'Keep going.',
      })

  useEffect(() => {
    const t = setTimeout(onClose, 4500)
    return () => clearTimeout(t)
  }, [onClose])

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div
      className="streak-celebration-backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="streak-celebration-text"
    >
      <div className="streak-celebration" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="streak-celebration-close"
          onClick={onClose}
          aria-label="Close"
        >×</button>
        <div className="streak-celebration-emoji" aria-hidden="true">
          {copy.emoji}
        </div>
        <div id="streak-celebration-text" className="streak-celebration-text">
          {copy.text}
        </div>
        <div className="streak-celebration-sub">{copy.sub}</div>
      </div>
    </div>
  )
}
